import styled from 'styled-components';

export const MultiSelectionFilterWrapper = styled.div`
  user-select: none;
`;

export const Title = styled.div`
  display: flex;
  font-weight: bold;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.eclipse};

  & span {
    font-weight: normal;
    padding-left: 2px;
  }
`;

export const MultiSelectionItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 14px 0 12px 0;
`;

export const MultiSelectionItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CollapseHeaderSubTitleStyle = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.brownishGrey};
`;

export const ExtraFieldValueStyle = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.brownishGrey};
  margin-right: 3px;
  text-align: end;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-right: 0px;
  }
  min-width: 100px;
`;

export const SubTitle = styled.span`
  margin-left: 5px;
  color: ${({ theme }) => theme.palette.grey700};
  font-size: 12px;
  line-height: 16px;
  min-width: 140px;
`;

export const CheckboxLabel = styled.div`
  word-break: break-word;
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;

export const CollapsibleFilterItemsWrapper = styled.div<{
  $isScrollable?: boolean;
}>`
  ${({ $isScrollable }) =>
    $isScrollable &&
    `
    max-height: 400px;
    overflow-y: auto;
    padding-right: 4px;
  `}
`;

export const ShowMoreButton = styled.button`
  display: block;
  padding: 0;
  margin: 10px 0 0;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.palette.clearBlue};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
`;
